export default __webpack_public_path__ + "static/media/logo.1565fbef.png";